import script from "./LoadingBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingBar.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingBar.vue?vue&type=style&index=0&id=583dac2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583dac2c"]])

export default __exports__